<template>
<div id="sale_franchise">
    <link href="/static/css/general/style2.css" rel="stylesheet">
    <div class="header">
        <div class="header-top">
            <div class="wrapper clearfix">
                <div class="col-xs-120">
                    <div class="logo">
                        <router-link to="/"><img src="/static/img/general/logo-franchise.png"></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="franchise_blocks">
            <div class="franchise_block">
                <router-link to="/sale-franchise/">
                    <p>Информация <br> по франчайзингу</p>
                </router-link>
            </div>
            <div class="franchise_block franchise_block_two">
                <router-link to="/sale-investment/">
                    <p>Инвестировать <br> в открытие <br> <span>без участия в управлении</span></p>
                </router-link>
            </div>
            <div class="franchise_block franchise_block_two">
                <router-link to="/saas-rus/">
                    <p>Создать свой агрегатор<br><br> <span>и не зависеть от франшизы</span></p>
                </router-link>
            </div>
        </div>
        <div class="header-bottom">
            <div class="wrapper clearfix">
                <div class="col-md-25 col-md-offset-3">
                    <ul>
                        <li>■ Минимальные вложения;</li>
                        <li>■ Даём эксклюзив на город или страну;</li>
                    </ul>
                </div>
                <div class="col-md-40 col-md-offset-13">
                    <ul>
                        <li>■ Настоящий интернет-бизнес;</li>
                        <li>■ Мы помогаем автосервисам находить клиентов;</li>
                    </ul>
                </div>
                <div class="col-md-30 col-md-offset-7">
                    <ul>
                        <li>■ Станьте партнером национальной сети по ремонту автомобилей;</li>
                    </ul>
                </div>
                <div class="col-xs-120">
                    <div class="business">Бизнес в 4 шага</div>
                </div>
                <div class="clearfix"></div>
                <div class="col-md-17 col-sm-60 no-padding">
                    <div class="item item-1">заключаете договоры с автосервисами, мойками, дилерами</div>
                </div>
                <div class="col-md-15 col-sm-60 no-padding">
                    <div class="item item-arrow"></div>
                </div>
                <div class="col-md-14 col-sm-60 no-padding">
                    <div class=" item item-2">продвигаете сервис в своём городе</div>
                </div>
                <div class="col-md-15 col-sm-60 no-padding">
                    <div class="item item-arrow"></div>
                </div>
                <div class="col-md-16 col-sm-60 no-padding">
                    <div class=" item item-3">люди записываются на ремонт через наш сайт</div>
                </div>
                <div class="col-md-15 col-sm-60 no-padding">
                    <div class="item item-arrow"></div>
                </div>
                <div class="col-md-16 col-sm-60 no-padding">
                    <div class="item item-4">каждый час вы получаете процент с каждого ремонта</div>
                </div>
                <div class="col-xs-120">
                    <div class="business"  v-if="city.lang === 'ru'">ЗАРАБОТАЙ 550 000 ЗА ПЕРВЫЕ 3 МЕСЯЦА</div>
                    <div class="business"  v-else>ЗАРАБОТАЙ 7 500$ ЗА ПЕРВЫЕ 3 МЕСЯЦА</div>
                </div>
            </div>
        </div>
    </div>
    <div class="read-more">
        <div class="wrapper clearfix">
            <div class="col-xs-120 no-padding">
                <h2 v-if="city.lang === 'ru'">ФРАНШИЗА СТОИТ ВСЕГО 55Т.РУБ ДО 10.05.20Г. Роялти 4650 РУБ/МЕС.<br/> 100% Компенсация взноса и роялти от государства</h2>
                <h2 v-else>ФРАНШИЗА СТОИТ ВСЕГО 72 ДОЛЛАРА</h2>
                <div id="application_franchise">
                    <div class="col-md-24 col-sm-60 padding">
                        <input type="text" name="name" placeholder="Ваше имя" v-model="user.name">
                    </div>
                    <div class="col-md-24 col-sm-60 padding">
                        <input type="text" name="city" placeholder="Ваш город" v-model="citys">
                    </div>
                    <div class="col-md-24 col-sm-60 padding">
                        <input v-model="user.phone" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" type="tel" placeholder="Тел. номер" required="" title="Пример: +7(901)234-56-78">
                    </div>
                    <div class="col-md-24 col-sm-60 padding">
                        <input type="text" name="email" placeholder="E-mail" required="" v-model="user.email"  title="Пример: example@mail.ru">
                    </div>
                    <div class="col-md-24 col-xs-120 padding">
                        <button @click="sendOffer">Узнать как</button>
                    </div>
                    <div class="clearfix"></div>
                    <div class="error alert alert-danger" v-if="errors.length > 0">
                        <p v-for="(error, index) in errors" :key="index">{{error}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="result">
        <div class="wrapper yellow-line clearfix">
            <div class="col-xs-120">
                <h2>Вот так наш партнёр видит, сколько он зарабатывает</h2>
            </div>
            <div class="col-sm-120 no-padding">
                <div class="screenshot">
                    <img src="/static/img/general/screenshot-new.png">

                </div>
                <div class="screenshot">
                    <iframe class="video_block" src="https://www.youtube.com/embed/NUncqG0C9Wg" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0"></iframe>
                </div>
            </div>
            <!--
                        <div class="col-sm-80 no-padding">
                            <div class="block-text">
                                <h3>Всегда стремитесь к большему</h3>
                                <p>Вы можете смотреть статистику заказов в других городах и пообщаться с коллегами, которые достигают лучших результатов, узнать как они это делают и взять на воружение их “фишки”.</p>
                            </div>
                        </div>
            -->
        </div>
    </div>
    <div class="market">
        <div class="wrapper clearfix">
            <div class="col-sm-110 no-padding">
                <div class="screenshot"><!--<iframe class="video_block" src="https://www.youtube.com/embed/reeFelLjm5I
                                                    " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0"></iframe>-->
                    <iframe class="video_block" src="https://www.youtube.com/embed/_YN_b9ZRi-g
                                                    " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0"></iframe>
                </div>
                <h2>Всегда стремитесь к большему</h2>
                <p>Вы можете смотреть статистику заказов в других городах и пообщаться с коллегами, которые достигают лучших результатов, узнать как они это делают и взять на воружение их “фишки”.</p>
                <p>Агрегатор В-Автосервис, как высокотехнологичный продукт прошел экспертизу в ИТ Технопарк Российской Кремниевой Долины СКОЛКОВО. До этого, успешно пройдено две крупные акселераторские программы, в том числе, программы Технопарка. Высокие оценки достигнутых результатов – главный показатель технологичности и эффективности, которые получают наши партнеры в регионах.</p>
            </div>
        </div>
    </div>
    <div class="market">
        <div class="wrapper clearfix">
            <div class="col-sm-110 no-padding">
                <div class="screenshot"><!--<iframe class="video_block" src="https://www.youtube.com/embed/6rIJAnCY08I
                                                    " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0"></iframe>-->
                    <iframe class="video_block" src="https://www.youtube.com/embed/iSKxvlhLQ24
                                                    " allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" frameborder="0"></iframe>
                </div>
                <h2>Тенденции рынка</h2>
                <p align="left"> Рынок растет, поскольку происходит перераспределение каналов обращения - раньше люди самостоятельно искали сервис, записывались, покупали запчасти подешевле, а сейчас все это делают агрегаторы: от подбора ближайшего сервиса по самой низкой цене до доставки запчасти в сервис прямо к началу ремонта.</p>
                <p>Ни один другой агрегатор автосервисов не предоставляет возможности работать по франшизе и это объяснимо. Многомиллионный рынок каждого города они захватывают самостоятельно. Мы же нацелены на партнерство, поскольку доказали на практике то, что региональный представитель в своем городе способен добиться гораздо больших успехов за счет знания местного рынка и высокой заинтересованности в успехе.</p>
            </div>
        </div>
    </div>
    <div class="question-answer">
        <div class="wrapper clearfix">
            <h2>Пока ещё у Вас есть возможность получить эту франшизу...</h2>
            <h3>В одном городе только один партнер!</h3>
            <div class="block-shadow clearfix">
                <div class="col-md-50 no-padding faq-links">
                    <p>Вопрос</p>
                    <hr>
                    <router-link to="#" data-id="1" class="active">На чем я, как партнер сайта, буду зарабатывать?</router-link>
                    <router-link to="#" data-id="2" class="">Вы указали, что есть еще 2 таких ресурса как Ваш. А какие другие? В чем отличия?</router-link>
                    <router-link to="#" data-id="3" class="">Какой смысл автосервисам давать такие скидки посетителям сайта?</router-link>
                    <router-link to="#" data-id="4">А почему автосервисы соглашаются работать с такими системами? Какой смысл? Раньше ведь не было таких сайтови все спокойно ехали и записывались</router-link>
                    <router-link to="#" data-id="5">А могу ли я открыться в нескольких городах?</router-link>
                    <router-link to="#" data-id="6">В каких странах можно приобрести франшизу? В СМИ идет информация о том, что агрегатор международный.</router-link>
                </div>
                <div class="col-md-50 col-md-offset-15">
                    <p>Ответ</p>
                    <hr>
                    <div class="faq-text faq-text-1" style="display: block;">Вы получаете % от каждого ремонта, который заказан через наш сайт. Также Вы получаете % от стоимости всех запчастей.</div>
                    <div class="faq-text faq-text-2" style="display: none;">Это Юремонт и Ремонтист. Отличие в технологичности. Наш сайт является самым дорогим и вложения в проект в размере нескольких миллионов долларов были потрачены на качественное программное обеспечение. Функционал - это главное отличие. Конечно же, имеющаяся система бонусов это еще один плюс и такой системы ни у кого нет.В любом случае, поток клиентов будет распределен между нашими сайтами, но с учетом количества автомобилей в каждом городе это совершенно не ощущается. В настоящее время три сайта никак не будут конкурировать между собой, поскольку главная задача тройки игроков – забрать автовладельцев уведя их от прямых поездок и звонков в сервисы на наши ресурсы.</div>
                    <div class="faq-text faq-text-3" style="display: none;">Это борьба за клиента. Если их цена будет выше к ним обратится меньше людей. Чем больше наш сайт продвигается в регионе, тем больше людей им пользуются. Следовательно, происходит четкое и планомерное перераспределение клиентов. Просто законы рынка</div>
                    <div class="faq-text faq-text-4 hide" style="display: none;">Здесь можно даже не искать смысл, ответ кроется в том, что у них не остается вариантов. Для автовладельцев наш ресурс функциональный и удобный, поэтому если автосервиса нет на нашем сайте они сразу же проигрывают. Вы правильно отметили: раньше таких сайтов не было, но ведь теперь они есть. Раньше и компьютеров и ноутбуков не было. Технологии берут верх. Экономия времени во всем мире выходит на первое место.</div>
                    <div class="faq-text faq-text-5 hide" style="display: none;">Конечно. У нас есть партнеры, которые заключили договоры на несколько городов.</div>
                    <div class="faq-text faq-text-6 hide" style="display: none;">Мы открываемся в 25 странах в том числе в 7 странах бывшего Союза. Но планы географического расширения на 2020 год большие, поэтому, если в списке интересующих Вас стран не окажется нужной, это можно всегда обсудить с Вашим персональным менеджером по развитию бизнеса.</div>
                </div>
            </div>
        </div>
    </div>
  <articles :articles="['/tri-igroka-na-rynke/', '/rynok-avtoservisa-rastet/', '/interv-yu/']"></articles>
    <div class="footer">
        <div class="wrapper clearfix">
            <div class="col-md-20 no-padding">
                <div class="logo">
                    <router-link to="/"><img src="/static/img/general/logo-franchise-footer.png"></router-link>
                </div>
            </div>
            <div class="col-md-1">
                <div class="line"></div>
            </div>
            <div class="col-md-31">
                <div class="become-partner">
                    Стать эксклюзивным партнером:
                </div>
            </div>
            <div class="col-md-30">
                <div class="contacts">
                    <router-link to="#" class="phone">
                        <!--8 800 201-32-36-->
                    </router-link>
                    <a href="mailto:info@olimpgrup.ru" class="email">info@olimpgrup.ru</a>
                    <span v-if="city.lang === 'ru'">+79381444265 (Viber/WhatsApp)<br/>АНО "ПАУ" ОГРН 1166100052128</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import Articles from '@/components/blocks/Articles'
export default {
  name: 'SaleFranchise',
  props: ['city', 'user', 'auth'],
  components: {Articles},
  data () {
    return {
      errors: [],
      citys: this.city.name
    }
  },
  methods: {
    sendOffer () {
      this.errors = []
      if (!this.citys) this.errors.push('Необходимо указать город')
      if (!this.user.name) this.errors.push('Необходимо указать имя')
      if (!this.user.phone) this.errors.push('Необходимо указать телефон')
      if (!this.user.email) this.errors.push('Необходимо указать почту')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        formData.append('crm', '1')
        formData.append('pipe', '3')
        formData.append('lead[36]', this.citys)
        formData.append('note', 'Заявка на франшизу')
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )

        var formDatas = new FormData()
        formDatas.append('crm', '7')
        formDatas.append('pipe', '13')
        formDatas.append('lead[102]', 'В-Автосервис ' + this.city.name + '(' + this.city.lang + ')')
        formDatas.append('lead[103]', this.citys)
        formDatas.append('note', 'Заявка на франшизу')
        formDatas.append('contact[name]', this.user.name)
        formDatas.append('contact[100]', this.user.phone)
        formDatas.append('contact[101]', this.user.email)
        formDatas.append('contact[106]', this.citys)
        formDatas.append('contact[107]', 'В-Автосервис ' + this.city.name + '(' + this.city.lang + ')')
        axios.post('https://franch.v-avtoservice.com/api/import-lead',
          formDatas,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  },
  mounted () {
    $('body').on('click', '.faq-links a', function () {
      var id = $(this).attr('data-id')
      $('.faq-links a').removeClass('active')
      $(this).addClass('active')
      $('.faq-text').hide()
      $('.faq-text-' + id).removeClass('hide').show()
      return false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SaleFranchise.vue